import { useEffect, useState } from 'react'

const STILL_READING_AFTER_MS = 4000

/** Status line content while phenotypes generate. Remount it when a new generation starts. */
export function ClinicalSummaryGeneratingStatus() {
  const [stillReading, setStillReading] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => setStillReading(true), STILL_READING_AFTER_MS)
    return () => clearTimeout(timer)
  }, [])

  return (
    <>
      <span className="size-2 shrink-0 rounded-full bg-brand-800 motion-safe:animate-[clinical-summary-pulse_1.2s_ease-in-out_infinite]" />
      {stillReading ? 'Still reading, almost there' : 'Finding phenotypes'}
    </>
  )
}
